import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiUser, FiShoppingBag, FiTruck, FiArrowRight } from 'react-icons/fi';

const ROLES = [
  {
    id: 'individual_buyer',
    icon: '🏠',
    title: 'Individual Buyer',
    desc: 'Buy fresh farm produce for your home. No minimum order quantity.',
    color: '#DCFCE7',
    borderColor: '#15803D',
  },
  {
    id: 'retailer',
    icon: '🏪',
    title: 'Retailer',
    desc: 'Special pricing for your shop or store. Regular supply with flexible orders.',
    color: '#DBEAFE',
    borderColor: '#2563EB',
  },
  {
    id: 'wholesale_buyer',
    icon: '🏭',
    title: 'Wholesale Buyer',
    desc: 'Bulk quantities at the best prices. Direct from farm to your warehouse.',
    color: '#FEF3C7',
    borderColor: '#D97706',
  },
  {
    id: 'farmer',
    icon: '🌾',
    title: 'Farmer / Producer',
    desc: 'Sell your dairy, vegetables, fruits, flowers & food products directly to buyers.',
    color: '#F0FDF4',
    borderColor: '#15803D',
  },
];

const ChooseRoleSignupPage = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  return (
    <div className="container py-5" style={{ maxWidth: '800px' }}>
      <div className="text-center mb-5">
        <h2 className="fw-bold">🌾 Join FarmDirectly</h2>
        <p className="text-muted">How would you like to use FarmDirectly?</p>
      </div>

      <div className="row g-3">
        {ROLES.map((role) => (
          <div key={role.id} className="col-md-6">
            <div
              className="p-4 rounded-3 h-100"
              style={{
                background: selected === role.id ? role.color : '#FFF',
                border: `2px solid ${selected === role.id ? role.borderColor : '#E5E5E5'}`,
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onClick={() => setSelected(role.id)}
            >
              <div style={{ fontSize: '2.5rem', marginBottom: '8px' }}>{role.icon}</div>
              <h5 className="fw-bold mb-1">{role.title}</h5>
              <p className="text-muted small mb-0">{role.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-lg px-5 py-2"
          style={{
            background: selected ? '#15803D' : '#D4D4D4',
            color: '#FFF',
            fontWeight: 700,
            borderRadius: '8px',
            border: 'none',
          }}
          disabled={!selected}
          onClick={() => navigate(`/register/${selected}`)}
        >
          Continue <FiArrowRight className="ms-2" />
        </button>
      </div>

      <p className="text-center text-muted mt-3">
        Already have an account? <Link to="/login" className="fw-semibold" style={{ color: '#15803D' }}>Log in</Link>
      </p>
    </div>
  );
};

export default ChooseRoleSignupPage;
